import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

export const largeDeliverisValuesList = {
  accessToPalletJack: { label: 'Access to pallet jack', value: 'pallet_jack' },
  accessToForklift: { label: 'Access to forklift', value: 'forklift' },
  highCapacityColdStorage: { label: 'High capacity cold storage', value: 'high_capacity_cold_storage' },
  highCapacityStorage: { label: 'High capacity storage, non-temperature controlled', value: 'high_capacity' },
  onsiteLoadingDock: { label: 'Onsite loading dock ', value: 'loading_dock' },
};

const LargeDeliveriesSelector = () => {
  const { control, watch } = useFormContext();

  return (
    <Box>
      <Box>
        <Typography variant="h6" component="h2">
          Are you able to receive large deliveries?
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant="body2">
          Food Rescue US will occasionally receive large donations of a{' '}
          <b>
            <u>pallet or more of food</u>
          </b>
          . Please check any boxes below that are applicable to your agency.
        </Typography>
      </Box>

      <FormControlLabel
        label={largeDeliverisValuesList.accessToPalletJack.label}
        control={
          <Controller
            name={`large_deliveries.${largeDeliverisValuesList.accessToPalletJack.value}`}
            control={control}
            as={(props) => (
              <Checkbox
                checked={watch(`large_deliveries.${largeDeliverisValuesList.accessToPalletJack.value}`)}
                onChange={(e) => props.onChange(e.target.checked)}
                color="secondary"
              />
            )}
          />
        }
      />
      <FormControlLabel
        label={largeDeliverisValuesList.accessToForklift.label}
        control={
          <Controller
            name={`large_deliveries.${largeDeliverisValuesList.accessToForklift.value}`}
            control={control}
            as={(props) => (
              <Checkbox
                checked={watch(`large_deliveries.${largeDeliverisValuesList.accessToForklift.value}`)}
                onChange={(e) => props.onChange(e.target.checked)}
                color="secondary"
              />
            )}
          />
        }
      />
      <FormControlLabel
        label={largeDeliverisValuesList.highCapacityColdStorage.label}
        control={
          <Controller
            name={`large_deliveries.${largeDeliverisValuesList.highCapacityColdStorage.value}`}
            control={control}
            as={(props) => (
              <Checkbox
                checked={watch(`large_deliveries.${largeDeliverisValuesList.highCapacityColdStorage.value}`)}
                onChange={(e) => props.onChange(e.target.checked)}
                color="secondary"
              />
            )}
          />
        }
      />
      <FormControlLabel
        label={largeDeliverisValuesList.highCapacityStorage.label}
        control={
          <Controller
            name={`large_deliveries.${largeDeliverisValuesList.highCapacityStorage.value}`}
            control={control}
            as={(props) => (
              <Checkbox
                checked={watch(`large_deliveries.${largeDeliverisValuesList.highCapacityStorage.value}`)}
                onChange={(e) => props.onChange(e.target.checked)}
                color="secondary"
              />
            )}
          />
        }
      />
      <FormControlLabel
        label={largeDeliverisValuesList.onsiteLoadingDock.label}
        control={
          <Controller
            name={`large_deliveries.${largeDeliverisValuesList.onsiteLoadingDock.value}`}
            control={control}
            as={(props) => (
              <Checkbox
                checked={watch(`large_deliveries.${largeDeliverisValuesList.onsiteLoadingDock.value}`)}
                onChange={(e) => props.onChange(e.target.checked)}
                color="secondary"
              />
            )}
          />
        }
      />
    </Box>
  );
};

export default LargeDeliveriesSelector;
